import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '../../button/button.component';
import { AdjustDropdownHeightDirective } from '../../../directives/adjust-dropdown-height.directive';
import { ResetDropdownFilterDirective } from '../../../directives/reset-dropdown-filter.directive';
import { TableColumnsType } from '../../../enums/common';
import { ActionsPlacement, IFilterInput } from '../../../interfaces/filter-input.interface';
import { UserRole } from '../../../../core/auth/enums/userRoles';
import { TooltipOptions } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectFilterOptions, SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectTooltipPipe } from './multiselect-tooltip.pipe';

@Component({
  selector: 'app-filters-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    InputNumberModule,
    MultiSelectModule,
    CheckboxModule,
    DatePickerModule,
    SelectModule,
    ButtonComponent,
    TooltipModule,
    ResetDropdownFilterDirective,
    AdjustDropdownHeightDirective,
    CascadeSelectModule,
    MultiSelectTooltipPipe,
  ],
  templateUrl: './filters-form.component.html',
  styleUrl: './filters-form.component.scss',
})
export class FiltersFormComponent {
  readonly filterForm = input<FormGroup | null>(null);
  readonly filterActionsPlacement = input<ActionsPlacement>('end');
  readonly filters = input<IFilterInput[]>([]);
  readonly clearButtonText = input<string>('Clear');
  readonly ApplyButtonText = input<string>('Apply');

  public readonly formSubmit = output<FormGroup>();
  public readonly clearFilters = output<void>();
  public readonly cancel = output<void>();

  tableColumnsType = TableColumnsType;
  isAdmin = localStorage.getItem('role')?.toLowerCase() == UserRole.Admin;
  tooltipOptions: TooltipOptions = {
    showDelay: 500,
    tooltipEvent: 'hover',
    tooltipPosition: 'bottom',
  };

  get isApplyButtonDisabled(): boolean {
    return !this.isFormChanged();
  }

  submit() {
    this.formSubmit.emit(this.filterForm()!);
  }

  onClearFilters() {
    this.clearFilters.emit();
  }

  private isFormChanged(): boolean {
    const filterForm = this.filterForm();
    if (!filterForm) {
      return false;
    }

    return Object.values(filterForm.value).some(value => {
      if (value instanceof Date) {
        return true;
      }
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        return Object.values(value).some(v => v !== null && v !== '');
      } else if (typeof value === 'object' && Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== null && value !== '';
    });
  }

  customFilterFunction(event: KeyboardEvent, options: SelectFilterOptions): void {
    if (options.filter) {
      options.filter(event);
    } else {
      console.error('Filter function is undefined.');
    }
  }

  clearMultiSelectFilter(multiSelectRef: MultiSelect) {
    if (multiSelectRef?.filterValue) {
      multiSelectRef.filterValue = '';
    }
  }
}
